'use client';

import { Transition } from '@headlessui/react';
import { useEffect, useState } from 'react';

export function FadeIn({ children }: { children: React.ReactNode }) {
	const [show, setShow] = useState(false);

	useEffect(() => {
		setShow(true);
		return () => setShow(false);
	}, []);

	return (
		<Transition show={show}>
			<div className="transition duration-300 ease-in-out data-[closed]:opacity-0">
				{children}
			</div>
		</Transition>
	);
}
